export default __webpack_public_path__ + "static/media/Bludgeon of the Icy Tomb.749e681f.jpg";